import React, {
  useState,
  useCallback,
  useEffect,
  use,
  useRef,
  useLayoutEffect,
} from "react";
import NavBar from "./NavBar";
import BackgroundImage from "./../images/contactus_background.jpg";
import { useNavigate } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { axiosReqConfig } from "../functions/axiosRequest";
import { API_IP } from "../global_variables";
import {
  subscribeTopic,
  getSubChannelTopic,
  MessageContentType,
  MessageRepository,
} from "@amityco/ts-sdk";
import { createTextMessage } from "./Amity/AmityProvider.ts";
import StarRating from "./UserPatientScreen/StarRating";
import { formatDistanceToNowStrict } from "date-fns";
import axios from "axios";
import "./Messages.css"

const MessagingPage = () => {
  const [list, setList] = useState([]);
  const [chatBoxName, setChatBoxName] = useState("");
  const [subChannelId, setSubChannelId] = useState(null);
  const [creator, setCreator] = useState("");
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [query, setQuery] = useState("");
  const [selectedProviderIndex, setSelectedProviderIndex] = useState(null);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [previews, setPreviews] = useState({});
  const messageBottomRef = useRef(null);
  const [isChatLoading, setIsChatLoading] = useState(false);

  const username = localStorage.getItem("username");
  const disposers = [];
  const subscribeSubChannel = (subChannel) => {
    disposers.push(subscribeTopic(getSubChannelTopic(subChannel)));
  };
  const handleSearchChange = (e) => {
    setQuery(e.target.value);
  };

  const handleChangeMessage = (e) => {
    setNewMessage(e.target.value);
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();

    if (!subChannelId) return;
    if (!newMessage) return;

    await createTextMessage(subChannelId, newMessage, username);
    setNewMessage("");
    scrollToTarget();
  };
  const getChannelMessages = useCallback(() => {
    const unsubscribe = MessageRepository.getMessages(
      { subChannelId, limit: 10000 },
      ({ data: messages, onNextPage, hasNextPage, loading, error }) => {
        messages.sort((a, b) => a.channelSegment - b.channelSegment);
        setMessages(messages);
      }
    );
    disposers.push(unsubscribe);
  }, [subChannelId, disposers]);

  const watchLatestMessage = useCallback((subChannelId) => {
    if (!subChannelId) return () => {};

    const unsub = MessageRepository.getMessages(
      { subChannelId, limit: 20, isDeleted: false },
      ({ data }) => {
        if (!data || !data.length) {
          setPreviews((prev) => ({ ...prev, [subChannelId]: undefined }));
          return;
        }

        const latest = data.reduce((a, b) => {
          if (!a) return b;
          const segA = a.channelSegment ?? 0;
          const segB = b.channelSegment ?? 0;
          return segB > segA ? b : a;
        }, null);

        setPreviews((prev) => ({
          ...prev,
          [subChannelId]: {
            text:
              latest?.data?.text ??
              (latest?.dataType === "image" ? "📷 Photo" : "New message"),
            createdAt: latest?.createdAt,
          },
        }));
      }
    );

    return unsub;
  }, []);

  const onClickProvider = (index) => {
    setSelectedProviderIndex(index);
    setSelectedProvider(list[index]);
    console.log(list[index]);
    setSubChannelId(list[index].channel_code);
  };

  const getChatList = async () => {
    try {
      const authToken = localStorage.getItem("token");
      const apiUrl = `${API_IP}/api/amity/channels`;
      const username = localStorage.getItem("username");
      axios
        .get(apiUrl, {
          params: { username: username },
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        })
        .then((response) => {
          setCreator("A" + response.data.userId);
          setList(response.data.chatList);
          console.log(response.data.chatList);
        })
        .catch((error) => {
          console.error(
            "Error fetching data from the API (getChannels):",
            error
          );
        });
    } catch (error) {
      console.log(error);
    }
  };
  const ChatListItem = ({ index, item, isSelected }) => {
    const scid = item.channel_code;
    const preview = previews[scid];
    return (
      <button
        disabled={isSelected}
        onClick={() => onClickProvider(index)}
        className={`MSG-list-item ${isSelected ? "MSG-item-active" : ""}`}
      >
        <div className="MSG-item-header">
          <div>
            <img
              src={
                item.provider_img[0] ??
                require("../images/avatar_placeholder_0.png")
              }
              alt="Provider Ava"
              className="MSG-item-avatar"
            />
          </div>
          <div className="MSG-item-name-wrapper">
            <div>{item.provider_array[0]}</div>
            <div className="MSG-item-title">
              {item.provider_title[0] ?? ""}
            </div>
          </div>
        </div>
        <div className="MSG-item-preview">
          <div>{preview?.text ?? "Start a conversation"}</div>
          <div>
            {formatDistanceToNowStrict(new Date(preview?.createdAt ?? 0), {
              addSuffix: true,
            })}
          </div>
        </div>
      </button>
    );
  };

  const MessageBubble = ({ message }) => {
    const messageDate = new Date(message.createdAt);
    const messageDateFormat = messageDate.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    return (
      <div
        className={`MSG-bubble-wrapper ${
          message.creatorId === creator
            ? "MSG-sender"
            : "MSG-receiver"
        }`}
      >
        <div
          className={`MSG-bubble ${
            message.creatorId === creator
              ? "MSG-bubble-sent"
              : "MSG-bubble-received"
          }`}
        >
          {message.creatorId !== creator ? (
            <div className="MSG-bubble-sender-name">{message.metadata?.data?.sender}</div>
          ) : (
            ""
          )}
          <div>{message.data?.text} </div>
          <div className="MSG-bubble-time">{messageDateFormat}</div>
        </div>
      </div>
    );
  };

  const scrollToTarget = () => {
    if (messageBottomRef.current) {
      messageBottomRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      getChatList();
    }
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    const disposers = [];
    list.forEach((item) => {
      const scid = item.channel_code;
      const d = watchLatestMessage(scid);
      if (d) disposers.push(d);
    });

    return () => disposers.forEach((fn) => fn && fn());
  }, [list, watchLatestMessage]);

  useEffect(() => {
    if (!subChannelId) return;

    setIsChatLoading(true);
    const unsubscribe = MessageRepository.getMessages(
      { subChannelId, limit: 50 },
      ({ data, onNextPage, hasNextPage, loading, error }) => {
        const sorted = [...data].sort(
          (a, b) => a.channelSegment - b.channelSegment
        );
        setMessages(sorted);
        setIsChatLoading(loading);
      }
    );

    return () => unsubscribe?.();
  }, [subChannelId]);
  return (
    <>
      <div className="MSG-container screen-container">
        <header className="screen-header">
          <div className="screen-header-text">
            <h1 className="screen-title">Messages</h1>
            <p className="screen-subtitle">Connect with your care providers and manage your appointments.</p>
          </div>
        </header>
        <div className="MSG-layout">
          <div className="MSG-sidebar">
            <div className="MSG-search-wrapper">
              <img
                src={require("../images/search-icon.png")}
                className="MSG-search-icon"
              />
              <input
                type="text"
                value={query}
                onChange={handleSearchChange}
                placeholder="Search..."
                className="MSG-search-input"
              />
            </div>
            <div className="MSG-list-body">
              {list.length !== 0 ? (
                <>
                  {list.map((target, index) => {
                    return (
                      <ChatListItem
                        key={index}
                        index={index}
                        isSelected={selectedProviderIndex === index}
                        item={target}
                      />
                    );
                  })}
                </>
              ) : (
                <>
                  <div className="MSG-empty-state">
                    <img
                      src={require("../images/no-message-pic.png")}
                      className="MSG-empty-image"
                    />
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="MSG-chat-area">
            <div className="MSG-chat-header">
              {selectedProvider == null ? (
                ""
              ) : (
                <>
                  <div className="MSG-chat-header-info">
                    <img
                      src={
                        selectedProvider.provider_img ??
                        require("../images/avatar_placeholder_0.png")
                      }
                      alt="Provider Ava"
                      className="MSG-chat-avatar"
                    />
                    <div className="MSG-chat-header-text">
                      <div className="MSG-chat-name">{selectedProvider.provider_array[0]}</div>
                      <div className="MSG-chat-title">
                        {selectedProvider.provider_title[0] ?? ""}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="MSG-chat-messages" id="chatBox">
              {selectedProvider == null ? (
                <div className="MSG-empty-state">
                  <span className="MSG-empty-text">Select a provider to start a chat</span>
                </div>
              ) : isChatLoading ? (
                <div className="MSG-empty-state">
                  <img
                    src={require("../images/loading_icon.gif")}
                    alt="Loading"
                    style={{ width: "40px", marginBottom: "15px" }}
                  />
                  <span className="MSG-empty-text">Loading messages...</span>
                </div>
              ) : (
                <>
                  {messages.map((m) => (
                    <MessageBubble key={m.messageId} message={m} />
                  ))}
                  <div ref={messageBottomRef}></div>
                </>
              )}
            </div>
            <form className="MSG-chat-input-form" onClick={(e) => handleSendMessage(e)}>
              <div className="MSG-input-wrapper">
                <input
                  type="text"
                  value={newMessage}
                  placeholder="Type a message..."
                  onChange={handleChangeMessage}
                  className="MSG-input-field"
                />
                <button className="MSG-send-btn">
                  <img
                    src={require("../images/send-icon.png")}
                    alt="SendIcon"
                  />
                </button>
              </div>
            </form>
          </div>
          <div className="MSG-detail-area">
            <div className="MSG-detail-avatar-wrapper">
              {selectedProvider == null ? (
                ""
              ) : (
                <>
                  <img
                    src={
                      selectedProvider.provider_img ??
                      require("../images/avatar_placeholder_0.png")
                    }
                    alt="Provider Ava"
                    className="MSG-detail-avatar"
                  />
                </>
              )}
            </div>
            <div className="MSG-detail-info">
              {selectedProvider == null ? (
                ""
              ) : (
                <>
                  <StarRating rating={4} maxStars={5} />
                  <div>Phone Number: {selectedProvider.provider_phone[0]}</div>
                  <div>Email: {selectedProvider.provider_email[0]}</div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MessagingPage;
